import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

const EnhancedTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.secondary.dark,
    boxShadow: theme.shadows[6],
    fontSize: 12,
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
  },
  [`&[data-popper-placement*="bottom"] .${tooltipClasses.arrow}`]: {
    marginTop: -16,
    width: '24px',
    height: '16px',
  },
  [`&[data-popper-placement*="top"] .${tooltipClasses.arrow}`]: {
    marginBottom: -16,
    width: '24px',
    height: '16px',
  },
  [`&[data-popper-placement*="right"] .${tooltipClasses.arrow}`]: {
    marginLeft: -16,
    width: '16px',
    height: '24px',
  },
  [`&[data-popper-placement*="left"] .${tooltipClasses.arrow}`]: {
    marginRight: -16,
    width: '16px',
    height: '24px',
  },
}));

export default EnhancedTooltip;
